import { createSelector } from 'reselect'
import { RootState } from 'stores'
import { IAnswer } from 'types/IAnswer'
import { IDemographics } from 'types/IDemographics'
import { IScore } from 'types/IScore'
import { IId } from 'types/IId'

/** Get the reader's answers from the store */
const getAnswers = (state: RootState) => state.answers

/** Get all the reader's answersReducer on the populism axis */
const getPopulismScores = createSelector(
  getAnswers,
  answers =>
    answers.filter(
      (answer: IAnswer | undefined) => answer && answer.axis === 'populism'
    )
)

/** Calculate the reader's populism score */
export const getPopulismScore = createSelector(
  getPopulismScores,
  scores =>
    scores.reduce(
      (previousValue: number, currentValue) =>
        // @ts-ignore
        previousValue + (currentValue.answer || 0),
      0
    )
)

/** Get the reader's answersReducer on the conservatism axis */
const getConservatismScores = createSelector(
  getAnswers,
  answers =>
    answers.filter(
      (answer: IAnswer | undefined) => answer && answer.axis === 'conservatism'
    )
)

/** Calculate the reader's conservatism score */
export const getConservatismScore = createSelector(
  getConservatismScores,
  scores =>
    scores.reduce(
      (previousValue: number, currentValue) =>
        // @ts-ignore
        previousValue + (currentValue.answer || 0),
      0
    )
)

/** Get all the readers' answersReducer */
export const getReaderAnswers = (
  state: RootState
): (IDemographics & IScore & IId)[] => state.readerAnswers
